import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import EdgesensorHighRoundedIcon from '@mui/icons-material/EdgesensorHighRounded';
import ViewQuiltRoundedIcon from '@mui/icons-material/ViewQuiltRounded';
import PaymentRoundedIcon from '@mui/icons-material/PaymentRounded';
import StyleRoundedIcon from '@mui/icons-material/StyleRounded';

const itemContents = {
    backend: `
    <ul>
        <li>
            Simplify deployment with Docker’s containerization, allowing you to set up, test, and deploy applications consistently across any environment.
        </li>
        <li>
            Take advantage of a robust Laravel backend, complete with Stripe payment integration, for a seamless billing experience. Launch Core’s ready-made Stripe endpoints enable secure payment processing, empowering you to start monetizing your product without the hassle of custom payment code.
        </li>
        <li>
            Includes essential starter endpoints, like Login, Logout, API token regeneration, and more.
        </li>
        <li>
            Provides secure MySQL database connectivity, giving you full control and reliable data handling.
        </li>
    </ul>`,
    frontend: `
    <ul>
        <li>
            Enhance user experience with React’s dynamic, component-based frontend, offering a responsive, interactive interface. Launch Core’s React integration allows you to build visually engaging, high-performance web applications that your users will love.
        </li>
        <li>
            Equipped with a landing page and login page, saving you hours in building the core foundation of your application.
        </li>
        <li>
            Integrated endpoint calls for your Laravel backend, plus an Auth component for protected views, making user data handling secure and efficient.
        </li>
    </ul>`,
    database: `
    <ul>
        <li>
            Leverage MySQL’s proven reliability for fast, secure, and scalable data management, ready to handle millions of transactions.
        </li>
        <li>
            Fully integrated with Laravel’s Eloquent ORM, simplifying complex queries and enabling smooth data relationships.
        </li>
        <li>
            Provides a structured database layer that scales with your user base, ensuring your app can grow with confidence.
        </li>
    </ul>`,
    payments: `
    <ul>
        <li>
            Accept payments immediately with pre-integrated Stripe endpoints, allowing for secure and efficient billing from day one.
        </li>
        <li>
            Stripe offers PCI-compliant, secure transactions, giving your users peace of mind during checkout.
        </li>
        <li>
            Supports multiple payment options, providing a seamless user experience that encourages conversions and boosts revenue.
        </li>
    </ul>`,
    styling: `
    <ul>
        <li>
            Material-UI offers a sleek, professional design with ready-to-use components that give your application an instant visual upgrade.
        </li>
        <li>
            Customizable theming allows you to quickly match brand colors, typography, and style, creating a consistent, memorable user experience.
        </li>
        <li>
            Access to a comprehensive component library for elements like buttons, forms, and cards, saving development time on custom styling.
        </li>
    </ul>`
};

const productItems = [
    {
        icon: <ViewQuiltRoundedIcon />,
        title: 'Backend',
        description:
            'Simplify deployment with Docker’s containerization, allowing you to set up, test, and deploy applications consistently across any environment. Take advantage of a robust Laravel backend, complete with Stripe payment integration, for a seamless billing experience.',
        itemContents: itemContents.backend,
    },
    {
        icon: <EdgesensorHighRoundedIcon />,
        title: 'Frontend',
        description:
            'Enhance user experience with React’s dynamic, component-based frontend, offering a responsive, interactive interface. Launch Core’s React integration allows you to build visually engaging, high-performance web applications that your users will love.',
        itemContents: itemContents.frontend,
    },
    {
        icon: <DevicesRoundedIcon />,
        title: 'Database',
        description:
            'Enjoy fast, secure, and scalable data management with MySQL, pre-configured to handle complex queries and provide real-time insights. Paired with Laravel’s Eloquent ORM, Launch Core offers a streamlined way to store and retrieve data effortlessly.',
        itemContents: itemContents.database,
    },
    {
        icon: <PaymentRoundedIcon />,
        title: 'Payments',
        description:
            'Start accepting payments right away with built-in Stripe endpoints. Launch Core ensures secure, PCI-compliant transactions, offering a smooth checkout experience for your users.',
        itemContents: itemContents.payments,
    },
    {
        icon: <StyleRoundedIcon />,
        title: 'Styling',
        description:
            'Achieve a professional design instantly with Material-UI’s extensive component library and easy theming options. Customize colors and typography for a cohesive brand experience.',
        itemContents: itemContents.styling,
    },
];

export default productItems;
